import { EXTENSION_MESSAGE_TYPES } from './enums'

const _MESSAGE_TYPE_KEY = '__messageType__'

export function createMessage(messageType, object) {
  return {
    ...object,
    [_MESSAGE_TYPE_KEY]: messageType,
  }
}

export function getMessageType(message) {
  return message[_MESSAGE_TYPE_KEY]
}

export function validateExtensionMessage(message, sender) {
  const messageType = getMessageType(message)

  return (
    Object.values(EXTENSION_MESSAGE_TYPES).includes(messageType) &&
    sender.id === chrome.runtime.id
  )
}
